import { useMemo } from 'react';

import { useWindowSize } from '@wwe-portal/ui/hooks/use-window-size';
import { useResponsive } from '@wwe-portal/ui/hooks/use-responsive';

import { flattenContent, getEstimatedSizes } from '../lib/helper';

import type { StoreContentItemsProps } from './use-virtualize-content';

export const useExtractVirtualRows = ({
  content,
}: {
  content: StoreContentItemsProps[];
}) => {
  const { sm, lg, xl3 } = useResponsive();
  const { width } = useWindowSize();
  const { rows, categoryIndexes } = useMemo(() => {
    return flattenContent(content, { sm, xl3 });
  }, [content, sm, xl3]);

  const estimatedSizes = useMemo(() => {
    return getEstimatedSizes(rows, { width, xl3, lg, sm });
  }, [rows, sm, lg, xl3, width]);

  return {
    rows,
    categoryIndexes,
    estimatedSizes,
  };
};
